module.exports = __webpack_public_path__ + "static/media/download-zip.99dc4d3d.svg";